export default __webpack_public_path__ + "static/media/policy-n-resources.3b60435a.svg";